// extracted by mini-css-extract-plugin
export default {"successMessage":"success-message_successMessage__hHZCB"};